/**
 * Marketing configuration constants
 */

/**
 * List of all marketing parameter keys to track
 */
export const MARKETING_PARAM_KEYS = [
  // UTM parameters
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_campaign',
  'utm_term',
  // Ad platform click IDs
  'gclid', // Google Ads
  'fbclid', // Facebook
  'msclkid', // Microsoft
  '_gl', // Google Analytics Linker
] as const

/**
 * Type for marketing parameter keys
 */
export type MarketingParamKey = (typeof MARKETING_PARAM_KEYS)[number]

/**
 * Default cookie options for marketing parameters
 */
export const DEFAULT_MARKETING_COOKIE_OPTIONS = {
  maxAge: 60 * 60 * 24, // 24 hours
  path: '/',
  httpOnly: false,
  secure: process.env.NODE_ENV === 'production',
} as const

/**
 * URL parameter used to indicate final redirect
 */
export const FINAL_URL_PARAM = 'finalUrl' as const

/**
 * Default source when no UTM source is found
 */
export const DEFAULT_SOURCE = 'direct' as const
